import React from 'react';
import './RejectMessage.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { preserveAllUrlParams, restoreDynamicParamsFromStorage } from '../../utils/urlParams';

const RejectMessage = ({ onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeClick = () => {
    // Preserve all URL parameters (both registered and dynamic)
    const searchParams = preserveAllUrlParams(location.search);
    
    // Restore dynamic parameters from localStorage if not in URL
    restoreDynamicParamsFromStorage(searchParams);
    
    // Ensure required parameters have defaults if missing
    if (!searchParams.has("lar")) {
      const larFromStorage = localStorage.getItem("lar") || "admin";
      searchParams.set("lar", larFromStorage);
    }
    if (!searchParams.has("utm_source")) {
      const sourceFromStorage = localStorage.getItem("utm_source") || "direct";
      searchParams.set("utm_source", sourceFromStorage);
    }
    
    // Handle optional parameters from localStorage if not in URL
    if (!searchParams.has("utm_term")) {
      const kwFromStorage = localStorage.getItem("utm_term");
      if (kwFromStorage) {
        searchParams.set("utm_term", kwFromStorage);
      }
    }
    
    if (!searchParams.has("utm_campaign")) {
      const campaignFromStorage = localStorage.getItem("utm_campaign");
      if (campaignFromStorage) {
        searchParams.set("utm_campaign", campaignFromStorage);
      }
    }
    
    if (!searchParams.has("utm_type")) {
      const utmTypeFromStorage = localStorage.getItem("utm_type");
      if (utmTypeFromStorage) {
        searchParams.set("utm_type", utmTypeFromStorage);
      }
    }
    
    navigate(`${process.env.REACT_APP_BASE_URL}?${searchParams.toString()}`);
  };

  return (
    <div className="reject-form-container">
      <div className="reject-question-container">
        <div className="reject-questions-box">
          <div className="reject-question">
            Sorry, we cannot proceed further
          </div>
        </div>
        <div className="reject-navigation-buttons">
          <button onClick={handleHomeClick}>Home</button>
          <button onClick={onBack}>Back</button>
        </div>
      </div>
    </div>
  );
};

export default RejectMessage;